/* eslint-disable react/jsx-props-no-spreading */
import { Box, Tooltip, TooltipProps } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

export interface OverflowToolTipProps {
  children: React.ReactNode;
  watchKey?: string;
  tooltipProps?: Partial<TooltipProps>;
  sx?: object;
}

function OverflowToolTip({
  children,
  watchKey,
  tooltipProps,
  sx = {},
}: OverflowToolTipProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  const checkOverflow = () => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  };

  useEffect(() => {
    checkOverflow();
    const resizeObserver = new ResizeObserver(checkOverflow);
    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [children, watchKey]);

  return (
    <Tooltip
      title={children}
      disableHoverListener={!isOverflowed}
      {...tooltipProps}
    >
      <Box
        ref={textRef}
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...sx,
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}

OverflowToolTip.defaultProps = {
  watchKey: undefined,
  tooltipProps: {},
  sx: {},
};

export default OverflowToolTip;
